export { default } from './FinalDocumentsSection';
